import React from 'react';
import { useOTPAuth } from '../../hooks/useOTPAuth';
import Button from '../ui/Button';
import StepIndicator from './StepIndicator';
import EmailStep from './EmailStep';
import OTPStep from './OTPStep';

const LoginForm: React.FC = () => {
    const {
        email,
        setEmail,
        otp,
        setOtp,
        currentStep,
        isLoading,
        sendCode,
        verifyCode,
        resendCode,
        backToEmail,
    } = useOTPAuth();

    return (
        <div className="form-container">
            <StepIndicator currentStep={currentStep} />

            {currentStep === 1 ? (
                <EmailStep
                    email={email}
                    setEmail={setEmail}
                    onSendCode={sendCode}
                    isLoading={isLoading}
                />
            ) : (
                <OTPStep
                    otp={otp}
                    setOtp={setOtp}
                    email={email}
                    onVerifyCode={verifyCode}
                    onResendCode={resendCode}
                    onBackToEmail={backToEmail}
                    isLoading={isLoading}
                />
            )}
        </div>
    );
};

export default LoginForm;